/* Inline Color / Size / Collections filters for collection pages, styled to
   match Sort by. Reads data-filter-color / data-filter-sizes / data-filter-category
   from each product card and shows/hides cards client-side. Color & Size options
   are built from the products present; the Collections options are fixed (rendered
   server-side, Shop All page only). */
(function () {
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '2XL', '3XL'];
  var LABELS = { color: 'Color', size: 'Size', category: 'Collections' };
  var ALL = { color: 'All Colors', size: 'All Sizes' };

  function normSize(s) { return (s || '').split('(')[0].trim().toUpperCase(); }
  function esc(s) { return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function sizeSort(a, b) {
    var ia = SIZE_ORDER.indexOf(a.toUpperCase()), ib = SIZE_ORDER.indexOf(b.toUpperCase());
    if (ia === -1 && ib === -1) return a.localeCompare(b);
    if (ia === -1) return 1;
    if (ib === -1) return -1;
    return ia - ib;
  }

  function init() {
    var wrap = document.querySelector('[data-collection-wrapper]');
    var controls = Array.prototype.slice.call(document.querySelectorAll('[data-filter-control]'));
    if (!wrap || !controls.length) return;
    var countEl = document.querySelector('[data-products-count]');
    var state = { color: '', size: '', category: '' };

    function items() {
      return Array.prototype.slice.call(wrap.querySelectorAll('.product-grid-item[data-product-block]'));
    }

    function valuesFor(kind) {
      var set = {};
      items().forEach(function (it) {
        if (kind === 'color') {
          var c = (it.getAttribute('data-filter-color') || '').trim();
          if (c) set[c] = 1;
        } else if (kind === 'size') {
          (it.getAttribute('data-filter-sizes') || '').split(',').forEach(function (s) {
            s = normSize(s);
            if (s) set[s] = 1;
          });
        }
      });
      var arr = Object.keys(set);
      arr.sort(kind === 'size' ? sizeSort : function (a, b) { return a.localeCompare(b); });
      return arr;
    }

    // Does an item pass every ACTIVE filter except `exceptKind`? Used to compute
    // which options are still valid given the other selections (interdependence).
    function passOthers(it, exceptKind) {
      var ic = (it.getAttribute('data-filter-color') || '').trim();
      var isz = (it.getAttribute('data-filter-sizes') || '').split(',').map(normSize);
      var icat = (it.getAttribute('data-filter-category') || '').trim();
      return (exceptKind === 'color' || !state.color || ic === state.color) &&
        (exceptKind === 'size' || !state.size || isz.indexOf(state.size) !== -1) &&
        (exceptKind === 'category' || !state.category || icat === state.category);
    }

    // Set of values for `kind` that still yield >=1 product given the OTHER
    // active filters — the options we allow the user to pick.
    function availableFor(kind) {
      var set = {};
      items().forEach(function (it) {
        if (!passOthers(it, kind)) return;
        if (kind === 'color') {
          var c = (it.getAttribute('data-filter-color') || '').trim();
          if (c) set[c] = 1;
        } else if (kind === 'size') {
          (it.getAttribute('data-filter-sizes') || '').split(',').forEach(function (s) {
            s = normSize(s); if (s) set[s] = 1;
          });
        } else if (kind === 'category') {
          var cat = (it.getAttribute('data-filter-category') || '').trim();
          if (cat) set[cat] = 1;
        }
      });
      return set;
    }

    function popdown(ctrl) { return ctrl.querySelector('[data-filter-options]'); }
    function toggleBtn(ctrl) { return ctrl.querySelector('[data-filter-toggle]'); }
    function isOpen(ctrl) { return popdown(ctrl).classList.contains('collection__sort__option-wrapper--visible'); }
    function open(ctrl) { closeAll(ctrl); popdown(ctrl).classList.add('collection__sort__option-wrapper--visible'); toggleBtn(ctrl).setAttribute('aria-expanded', 'true'); }
    function close(ctrl) { popdown(ctrl).classList.remove('collection__sort__option-wrapper--visible'); toggleBtn(ctrl).setAttribute('aria-expanded', 'false'); }
    function closeAll(except) { controls.forEach(function (c) { if (c !== except) close(c); }); }

    function updateLabel(ctrl, kind) {
      ctrl.querySelector('[data-filter-label]').textContent = state[kind] || LABELS[kind];
      ctrl.classList.toggle('is-active', !!state[kind]);
    }

    // Rebuild the auto-generated (Color/Size) option lists from the products present.
    // Options that would yield 0 products given the other active filters are disabled.
    function buildOptions(ctrl) {
      var kind = ctrl.getAttribute('data-filter-control');
      if (ctrl.hasAttribute('data-fixed')) { refreshFixed(ctrl, kind); return; }
      var ul = ctrl.querySelector('ul');
      var name = 'filter_' + kind;
      var avail = availableFor(kind);
      var rows = [['', ALL[kind]]];
      valuesFor(kind).forEach(function (v) { rows.push([v, v]); });
      ul.innerHTML = rows.map(function (r, i) {
        var id = name + '_' + i;
        var checked = state[kind] === r[0] ? ' checked' : '';
        var dis = (r[0] && !avail[r[0]]) ? ' disabled' : '';
        var cls = 'collection__filter-tag' + (dis ? ' is-unavailable' : '');
        return '<li class="' + cls + '">' +
          '<input class="collection__sort__input" type="radio" name="' + name + '" id="' + id + '" value="' + esc(r[0]) + '"' + checked + dis + '>' +
          '<label class="collection__sort__button" for="' + id + '">' + esc(r[1]) + '</label></li>';
      }).join('');
    }

    // Server-rendered (fixed) control, e.g. Collections: keep its options but
    // disable those that would yield 0 products given the other selections.
    function refreshFixed(ctrl, kind) {
      var avail = availableFor(kind);
      Array.prototype.slice.call(ctrl.querySelectorAll('input[type="radio"]')).forEach(function (inp) {
        var dis = !!inp.value && !avail[inp.value];
        inp.disabled = dis;
        var li = inp.closest('.collection__filter-tag');
        if (li) li.classList.toggle('is-unavailable', dis);
      });
    }

    function apply() {
      var shown = 0;
      items().forEach(function (it) {
        var ic = (it.getAttribute('data-filter-color') || '').trim();
        var isz = (it.getAttribute('data-filter-sizes') || '').split(',').map(normSize);
        var icat = (it.getAttribute('data-filter-category') || '').trim();
        var ok = (!state.color || ic === state.color) &&
          (!state.size || isz.indexOf(state.size) !== -1) &&
          (!state.category || icat === state.category);
        it.classList.toggle('is-filtered-out', !ok);
        if (ok) shown++;
      });
      if (countEl) {
        if (countEl.getAttribute('data-count-suffix') === null) {
          var mm = (countEl.textContent || '').match(/\D.*$/);
          countEl.setAttribute('data-count-suffix', mm ? mm[0] : '');
        }
        countEl.textContent = shown + countEl.getAttribute('data-count-suffix');
        countEl.setAttribute('data-products-count', shown);
      }
    }

    controls.forEach(function (ctrl) {
      var kind = ctrl.getAttribute('data-filter-control');
      buildOptions(ctrl);
      updateLabel(ctrl, kind);
      toggleBtn(ctrl).addEventListener('click', function (e) {
        e.preventDefault();
        if (isOpen(ctrl)) close(ctrl); else open(ctrl);
      });
      // Delegated change handler survives option-list rebuilds.
      ctrl.addEventListener('change', function (e) {
        var t = e.target;
        if (t && t.matches && t.matches('input[type="radio"]')) {
          state[kind] = t.value;
          close(ctrl);
          // Rebuild every control so the remaining options reflect this selection
          // (interdependent — you can't pick a combination that renders 0 products).
          controls.forEach(function (c) {
            buildOptions(c);
            updateLabel(c, c.getAttribute('data-filter-control'));
          });
          apply();
        }
      });
    });

    // "Clear all" — reset every filter to its default (All).
    var clearBtn = document.querySelector('[data-filter-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        state.color = ''; state.size = ''; state.category = '';
        controls.forEach(function (c) {
          buildOptions(c);
          updateLabel(c, c.getAttribute('data-filter-control'));
          if (c.hasAttribute('data-fixed')) { var all = c.querySelector('input[value=""]'); if (all) all.checked = true; }
        });
        closeAll(null);
        apply();
      });
    }

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-filter-control]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });

    // Handle "load more" / infinite scroll WITHOUT a MutationObserver (which loops
    // against the theme's lazy-image DOM mutations). React only when the count changes.
    var lastCount = items().length;
    var t;
    window.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var n = items().length;
        if (n !== lastCount) {
          lastCount = n;
          controls.forEach(buildOptions);
          apply();
        }
      }, 250);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
